export default __webpack_public_path__ + "static/media/icon_property.1d2966e8.svg";